import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false,
  onClick
}) => {
  const baseClasses = 'bg-white rounded-xl border border-gray-200 shadow-sm transition-all duration-200';
  const hoverClasses = hover || onClick
    ? 'hover:shadow-lg hover:border-red-200 hover:-translate-y-0.5 cursor-pointer'
    : '';
  const clickClasses = onClick ? 'active:scale-[0.98]' : '';
  const finalClasses = `${baseClasses} ${hoverClasses} ${clickClasses} ${className}`;

  const content = <div className="p-6">{children}</div>;

  if (onClick) {
    return (
      <button onClick={onClick} className={finalClasses} type="button">
        {content}
      </button>
    );
  }

  return <div className={finalClasses}>{content}</div>;
};

interface CardHeaderProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  title,
  subtitle,
  icon,
  action
}) => {
  return (
    <div className="flex items-start justify-between mb-4">
      <div className="flex items-start gap-4 w-full">
        {icon && (
          <div className="w-14 h-14 bg-gradient-to-br from-red-500 to-red-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md">
            {icon}
          </div>
        )}
        <div className="flex-1 text-left">
          <h3 className="text-lg font-bold text-gray-900 text-left">{title}</h3>
          {subtitle && <p className="text-sm text-gray-500 mt-0.5 text-left">{subtitle}</p>}
        </div>
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
};

interface CardContentProps {
  children: ReactNode;
  className?: string;
}

export const CardContent: React.FC<CardContentProps> = ({
  children,
  className = ''
}) => {
  return <div className={`text-left ${className}`}>{children}</div>;
};

